import React from "react";

export default function TermsPrivacy() {
  return (
    <div className="max-w-6xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <div className="bg-white shadow-xl rounded-2xl">
        <div className="px-8 py-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-12 text-center">Legal Terms & Privacy Policy</h1>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">1. Company Information</h2>
              <div className="prose max-w-none">
                <p className="mb-4">SELEGO B.V., a private limited company (Besloten Vennootschap) incorporated under the laws of the Netherlands, with its registered office at Amsterdam, registered with the Dutch Chamber of Commerce under number 72125845.</p>
                
                <p className="mb-4">Corporate Details:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Legal Name: SELEGO B.V.</li>
                  <li>SIREN Number: 892265687</li>
                  <li>SIRET Number (Head Office): 89226568700012</li>
                  <li>KvK (Chamber of Commerce) Number: 72125845</li>
                  <li>DUNS® Number: 492719623</li>
                  <li>Share Capital: €2,000</li>
                  <li>Date of Incorporation: January 4, 2021</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">2. Terms of Service</h2>
              <div className="prose max-w-none">
                <p className="mb-4">These Terms of Service ("Terms") constitute a legally binding agreement between you and SELEGO B.V. ("Company," "we," "us," or "our") governing your access to and use of the Company's services.</p>

                <h3 className="text-xl font-semibold mb-4">2.1 Acceptance of Terms</h3>
                <p className="mb-4">By accessing or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, you must not access or use our services.</p>

                <h3 className="text-xl font-semibold mb-4">2.2 Service License and Restrictions</h3>
                <p className="mb-4">Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to use our services. You agree not to:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Use the services for any illegal purpose or in violation of any laws</li>
                  <li>Interfere with or disrupt the integrity or performance of the services</li>
                  <li>Attempt to gain unauthorized access to the services or related systems</li>
                  <li>Reproduce, duplicate, copy, sell, or resell any portion of the services</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">3. Privacy Policy</h2>
              <div className="prose max-w-none">
                <p className="mb-4">This Privacy Policy describes our policies and procedures on the collection, use, and disclosure of your information when you use our services.</p>

                <h3 className="text-xl font-semibold mb-4">3.1 Information Collection</h3>
                <p className="mb-4">We collect and process personal data in accordance with the General Data Protection Regulation (GDPR) and applicable data protection laws. The types of information we collect include:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Personal identification information (name, email address, phone number)</li>
                  <li>Usage data and analytics related to service interaction</li>
                  <li>Communication records and preferences</li>
                  <li>Technical data including IP address and browser information</li>
                </ul>

                <h3 className="text-xl font-semibold mb-4">3.2 Data Processing and Security</h3>
                <p className="mb-4">We implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk, including:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Encryption of personal data during transmission</li>
                  <li>Regular testing and evaluation of security measures</li>
                  <li>Restricted access to personal information</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">4. Contact Information</h2>
              <div className="prose max-w-none">
                <p className="mb-4">For any inquiries regarding these Terms or our Privacy Policy, please contact our legal department at:</p>
                <p className="font-medium">Email: office@selego.co</p>
                <p className="text-sm text-gray-600 mt-4">Last updated: January 1, 2024</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
